import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { SaldoInicialService, history } from "../../../services";
import { DataGrid } from "../../../components";
import { responseErros } from "../../../utils";
import { format } from "date-fns";
import { filtrosUrl, PermisoesHelper } from "../../../helpers";
import { FormFiltroAvancado, SaldoEmMassaDialog } from "./components";

const ListSaldoInicialView = () => {
  const [loading, setLoading] = useState(false);
  const [listaAjustes, setListaAjustes] = useState([]);
  const [rowCount, setRowCount] = useState(0);
  const [openDialogEmMassa, setOpenDialogEmMassa] = useState(false);
  const saldoInicialService = new SaldoInicialService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("saldo-inicial-visualizar");

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
      filtrar: true,
    },
    {
      field: "createdAt",
      headerName: "Data de Cadastro",
      flex: 1000,
      valueGetter: (params) =>
        format(new Date(params.value), "dd/MM/yyyy HH:mm"),
    },
  ];

  useEffect(() => {
    buscarAjusteEstoque();
  }, []);

  async function buscarAjusteEstoque(filtro = {}) {
    setLoading(true);
    const result = await saldoInicialService.getAll(filtro);
    if (!result.isAxiosError) {
      setListaAjustes(result.data.rows);
      setRowCount(result.data.count);
    } else {
      responseErros(result);
    }
    setLoading(false);
  }

  const buscarPesquisaAvancada = async (filter) => {
    setLoading(true);
    const porIntervalo = [];
    const filtrosAvancadosTemp = {
      ...filter,
    };
    if (
      filtrosAvancadosTemp.dataLancamentoStart &&
      filtrosAvancadosTemp.dataLancamentoEnd
    ) {
      porIntervalo.push({
        coluna: "createdAt",
        de: filtrosAvancadosTemp.dataLancamentoStart,
        ate: filtrosAvancadosTemp.dataLancamentoEnd,
      });
    }
    delete filtrosAvancadosTemp.dataLancamentoStart;
    delete filtrosAvancadosTemp.dataLancamentoEnd;
    const result = await saldoInicialService.getAllFiltroAvancado({
      ...filtrosAvancadosTemp,
      restritiva: true,
      porIntervalo,
    });
    if (!result.isAxiosError) {
      setListaAjustes(result.data.rows);
      setRowCount(result.data.count);
      delete filtrosAvancadosTemp.status;
      filtrosUrl.set(filtrosAvancadosTemp);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const onClickCadastrar = (descricao) => {
    if (descricao === "Saldo em Massa") {
      setOpenDialogEmMassa(true);
    } else {
      history.push("/estoque/saldo-inicial/create");
    }
  };

  function onClickEditarAjusteEstoque(id) {
    history.push(`/estoque/saldo-inicial/${id}`);
  }

  const sendServerDatagrid = (props) => {
    if (props.tipoFiltro == "simples") {
      buscarAjusteEstoque(props.filtros);
    } else {
      buscarPesquisaAvancada(props.filtros);
    }
  };

  const buttonSelectOpcoes = [
    {
      permission: permissoesHelper.temPermisao("saldo-inicial-cadastrar"),
      descricao: "Saldo em Massa",
    },
  ];

  return (
    <>
      <ListLayout
        title="Saldo Inicial"
        loading={loading}
        onClickCadastrar={onClickCadastrar}
        buttonSelectOpcoes={buttonSelectOpcoes}
        permissaoButton={permissoesHelper.temPermisao("saldo-inicial-cadastrar")}
      >
        <DataGrid
          rows={listaAjustes}
          columns={colunas}
          rowCount={rowCount}
          onClickEdit={onClickEditarAjusteEstoque}
          visualizarShow={permissoesHelper.temPermisao(
            "saldo-inicial-visualizar",
          )}
          editShow={permissoesHelper.temPermisao("saldo-inicial-editar")}
          paginationMode={"server"}
          sendServer={(props) => sendServerDatagrid(props)}
          FormFiltroAvancado={FormFiltroAvancado}
        />
      </ListLayout>
      <SaldoEmMassaDialog
        openDialog={openDialogEmMassa}
        setOpenDialog={setOpenDialogEmMassa}
        onSuccess={() => buscarAjusteEstoque()}
      />
    </>
  );
};

export default ListSaldoInicialView;
